var ltr6_module_radar = (function (ltr6_module_radar) {

    ltr6_module_radar.init = function(){
      

      // ================================================================
      // filter mobile
      // ================================================================
      $('#ltr6-wrapper .ltr6-interactive-radar-wrapper').on('click', '.ltr6-filter-menu-toggle', function(event) {
        event.preventDefault();
        if(!$('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-filters-col').hasClass('mobile-expanded')){
          ltr6_module_radar.openMobileFilterMenu($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
          // $(this).addClass('active');
          // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-filters-col').addClass('mobile-expanded');
          // ltr6_module_analytics.tracking_adobe('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
          // ltr6_module_analytics.tracking_decibel('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
        } else {
          ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
          // $(this).removeClass('active');
          // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-filters-col').removeClass('mobile-expanded');
        }
      });
      $('#ltr6-wrapper .ltr6-interactive-radar-wrapper').on('click', '.ltr6-apply-filters', function(event) {
        // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-filters-col').removeClass('mobile-expanded');
        ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      });

      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper').on('click', '.ltr6-filter-menu-toggle', function(event) {
        event.preventDefault();
        if(!$('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-filters-col').hasClass('mobile-expanded')){
          ltr6_module_radar.openMobileFilterMenu($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
          // $(this).addClass('active');
          // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-filters-col').addClass('mobile-expanded');
          // ltr6_module_analytics.tracking_adobe('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
          // ltr6_module_analytics.tracking_decibel('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
        } else {
          ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
          // $(this).removeClass('active');
          // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-filters-col').removeClass('mobile-expanded');
        }
      });
      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper').on('click', '.ltr6-apply-filters', function(event) {
        // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-filters-col').removeClass('mobile-expanded');
        ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
      });






      // ================================================================
      // filter toggles
      // ================================================================
      $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters ').on('change', '.ltr6-toggle-switch input', function(event) {
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));

        // repeat for the other one :/ <--- DO THIS BETTER!
        $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-filters .ltr6-toggle-switch[data-filter-name="'+$(this).parent().attr('data-filter-name')+'"] input').prop('checked',$(this).prop('checked')); // sync the other radar
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
      });

      $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-filters ').on('change', '.ltr6-toggle-switch input', function(event) {
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
        // repeat for the other one :/ <--- DO THIS BETTER!
        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters .ltr6-toggle-switch[data-filter-name="'+$(this).parent().attr('data-filter-name')+'"] input').prop('checked',$(this).prop('checked')); // sync the other radar
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      });





      // ================================================================
      // focus - expand accordion if going in to section
      // ================================================================
      $('#ltr6-wrapper .ltr6-radar-filters').on('focus', '.ltr6-toggle-switch input', function(event) {        
        var groups = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-groups .ltr6-filter-group');
        var group = $(this).closest('.ltr6-filter-group');

        if(group.hasClass('active')) return;

        groups.find('.ltr6-filter-group-content').css('height',0);
        groups.removeClass('active');
        group.addClass('active');
        group.find('.ltr6-filter-group-content').css('height','auto');
      });






      // // ================================================================
      // // grid / radar view toggle switch
      // // ================================================================

      // $('#ltr6-wrapper').on('click', '.ltr6-radar-view-button-group a', function(event) {
      //   event.preventDefault();
      //   var instance = $(this).closest('.ltr6-interactive-radar');//individual mode
      //   // var instance = $('#ltr6-wrapper'); // sync mode
      //   var view = $(this).attr('data-radar-view');
      //   setView(view,instance);
      // });

      // function setView(view,instance){

      //   // $(this).parent().parent().attr('data-view',view);
      //   // $('.ltr6-radar-top-controls', instance).attr('data-view',view);
      //   $(instance).attr('data-radar-view',view);

      //   if(view=='radar'){
      //     $('.ltr6-radar-view-button-group a[data-radar-view="radar"]', instance).addClass('active');
      //     $('.ltr6-radar-view-button-group a[data-radar-view="grid"]', instance).removeClass('active');

      //     $('.ltr6-radar-view', instance).show();
      //     $('.ltr6-grid-view', instance).css('display','none');
      //     // $('#ltr6-wrapper .ltr6-radar-top-controls .ltr6-tutorial-link').show();
      //   } else {
      //     $('.ltr6-radar-view-button-group a[data-radar-view="radar"]', instance).removeClass('active');
      //     $('.ltr6-radar-view-button-group a[data-radar-view="grid"]', instance).addClass('active');
          
      //     $('.ltr6-radar-view', instance).hide();
      //     $('.ltr6-grid-view', instance).css('display','block');
      //     // $('#ltr6-wrapper .ltr6-radar-top-controls .ltr6-tutorial-link').hide();
      //   }
      // }

      // setTimeout(function(){
      //   // setView('grid');
      // },500);









      // ================================================================
      // APPLY FILTERS
      // ================================================================

      Array.prototype.diff = function(arr2) {
          var ret = [];
          for(var i in this) {   
              if(arr2.indexOf(this[i]) > -1){
                  ret.push(this[i]);
              }
          }
          if(ret.length) {
            return ret;
          } else {
            return false;
          }
      };
      
      function checkFilter(array1,array2){
        if(array1.length) {
          array1 = array1.split(',');
          var matchingFilters = array1.diff(array2);
          if(matchingFilters.length>0){
            return true;
          }
        }
        return false;
      }
  
      // function intersect(arrays){
      //   var result = arrays.shift().filter(function(v) {
      //       return arrays.every(function(a) {
      //           return a.indexOf(v) !== -1;
      //       });
      //   });
      //   return result;
      //   // var result = arrays.shift().filter(function(v) {
      //   //     return arrays.every(function(a) {
      //   //         return a.indexOf(v) !== -1;
      //   //     });
      //   // });
      // }

      Array.prototype.intersect = function(arr2) {
          var ret = [];
          for(var i in this) {   
              if(arr2.indexOf(this[i]) > -1){
                  ret.push(this[i]);
              }
          }
          return ret;
      };


      ltr6_module_radar.apply_filters = function(radarInstance){
        // console.log('applying filters...');
        // var groups = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters .ltr6-filter-groups .ltr6-filter-group');
        // var groups = radarInstance.find('.ltr6-radar-filters .ltr6-filter-groups .ltr6-filter-group');
        var groups = $('.ltr6-radar-filters .ltr6-filter-groups .ltr6-filter-group', radarInstance);
        var filterCount = 0;

        var focus_areas_filters = [];
        var trend_clusters_filters = [];
        var sectors_filters = [];
        var nodeFadeSpeed = 100;

        // get toggle state of filter
        $.each(groups, function(index, val) {
          var group = $(this);
          var groupName = $(this).attr('data-filter-group');
          // console.log('checking filter group '+groupName);
          // var filters = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+groupName+'"] .ltr6-toggle-switch');
          var filters = $(this).find('.ltr6-toggle-switch');
          var thisFilterCount = 0;
          $.each(filters, function(index, val) {
            var filterName = $(this).attr('data-filter-name');
            if($(this).find('input').is(":checked")){
              // console.log('ACTIVE: '+filterName);
              thisFilterCount ++;

              if(groupName=='focus_area') focus_areas_filters.push(filterName);
              if(groupName=='trend_cluster') trend_clusters_filters.push(filterName);
              if(groupName=='sector') sectors_filters.push(filterName);

            } else {
              // console.log('INACTIVE: '+filterName);
            }
          });
          filterCount += thisFilterCount;
              // console.log(thisFilterCount + 'active filters');
          var activeText = '';
          if(thisFilterCount>0){
            var s = thisFilterCount>1 ? 's':'';
            activeText = '('+thisFilterCount+' active filter'+s+')';
            activeText2 = '('+thisFilterCount+' active filter'+s+')';
            // html = '('+thisFilterCount+' active)';
          }
          // console.log('html',activeText);
          // console.log('activeText2',activeText2);
          // $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+groupName+'"] .ltr6-filter-active-filters-count').html(html);
          // radarInstance.find('.ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+groupName+'"] .ltr6-filter-active-filters-count').html(html);
          $('.ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+groupName+'"] .ltr6-filter-active-filters-count', radarInstance).html(activeText);
          // radarInstance.find('.ltr6-filter-menu-toggle span.ltr6-active-filters-count').html(activeText2);
          // $('.ltr6-filter-menu-toggle span.ltr6-active-filters-count', radarInstance).html('ab');

        });

        // console.log('focus_areas_filters',focus_areas_filters);
        // console.log('trend_clusters_filters',trend_clusters_filters);
        // console.log('sectors_filters',sectors_filters);
        var matching_nodes = [];

        if(filterCount>0){
          // console.log(filterCount+' active filters');
          // radarInstance.find('.ltr6-radar-filters .ltr6-clear-filters').addClass('active');
          $('.ltr6-radar-filters .ltr6-clear-filters', radarInstance).addClass('active');
          $('.ltr6-radar-filters .ltr6-apply-filters', radarInstance).addClass('active');
          




          // ================================================================
          // FILTER
          // ================================================================
          // console.log(focus_areas_filters);
          // $('.ltr6-radar-view .ltr6-node', radarInstance).hide();


          // new method: OR for within group, AND for group intersect
          var focus_area_matching_nodes = [];
          var trend_cluster_matching_nodes = [];
          var sector_matching_nodes = [];
          // get all nodes that are filtered
          var nodes = $('.ltr6-radar-view .ltr6-node', radarInstance);
          $.each(nodes, function(index, val) {
            var trendName = $(this).attr('data-trend');
            // FOCUS AREAS
            var dataFilterFocusAreas = ($(this).attr('data-filter-focus-areas')).toString();
            if(checkFilter(dataFilterFocusAreas,focus_areas_filters)) focus_area_matching_nodes.push(trendName);//$(this).show();
            // TREND CLUSTERS
            var dataFilterTrendClusters = ($(this).attr('data-filter-trend-clusters')).toString();
            if(checkFilter(dataFilterTrendClusters,trend_clusters_filters)) trend_cluster_matching_nodes.push(trendName);//$(this).show();
            // SECTORS
            var dataFilterSectors = ($(this).attr('data-filter-sectors')).toString();
            if(checkFilter(dataFilterSectors,sectors_filters)) sector_matching_nodes.push(trendName);//$(this).show();
          });
          // all matching nodes
          matching_nodes = focus_area_matching_nodes.concat(trend_cluster_matching_nodes, sector_matching_nodes);

          // intersect
          if(focus_area_matching_nodes.length && trend_cluster_matching_nodes.length){
            matching_nodes = focus_area_matching_nodes.intersect(trend_cluster_matching_nodes);
          }
          if(focus_area_matching_nodes.length && sector_matching_nodes.length){
            matching_nodes = focus_area_matching_nodes.intersect(sector_matching_nodes);
          }
          if(trend_cluster_matching_nodes.length && sector_matching_nodes.length){
            matching_nodes = trend_cluster_matching_nodes.intersect(sector_matching_nodes);
          }
          if(focus_area_matching_nodes.length && trend_cluster_matching_nodes.length && sector_matching_nodes.length){
            matching_nodes = focus_area_matching_nodes.intersect(trend_cluster_matching_nodes);
            matching_nodes = matching_nodes.intersect(sector_matching_nodes);
          }


          // console.log('matching_nodes',matching_nodes);


          // SHOW / HIDE RADAR NODES
          // ================================================================

          $.each(nodes, function(index, val) {
              var trendName = $(this).attr('data-trend');
              if(matching_nodes.includes(trendName)){
                // $(this).fadeIn(nodeFadeSpeed);
                $(this).addClass('highlighted');
                $(this).removeClass('disabled');
              } else {
                // $(this).fadeOut(nodeFadeSpeed);
                $(this).removeClass('highlighted');
                $(this).addClass('disabled');
              }
          });

          // // old OR for everything method
          // var nodes = $('.ltr6-radar-view .ltr6-node', radarInstance);
          // $.each(nodes, function(index, val) {
          //   var show = false;
          //   // FOCUS AREAS
          //   var dataFilterFocusAreas = ($(this).attr('data-filter-focus-areas')).toString();
          //   if(checkFilter(dataFilterFocusAreas,focus_areas_filters)) show = true;//$(this).show();

          //   // TREND CLUSTERS
          //   var dataFilterTrendClusters = ($(this).attr('data-filter-trend-clusters')).toString();
          //   if(checkFilter(dataFilterTrendClusters,trend_clusters_filters)) show = true;//$(this).show();

          //   // SECTORS
          //   var dataFilterSectors = ($(this).attr('data-filter-sectors')).toString();
          //   if(checkFilter(dataFilterSectors,sectors_filters)) show = true;//$(this).show();

          //   if(show) {
          //     $(this).fadeIn(nodeFadeSpeed);
          //     // $(this).addClass('highlighted');
          //   } else {
          //     $(this).fadeOut(nodeFadeSpeed);
          //     // $(this).removeClass('highlighted');
          //   }
          // });





          // // SHOW / HIDE GRID BLOCKS
          // // ================================================================
          // var blocks = $('.ltr6-grid-view .ltr6-radar-grid-block', radarInstance);
          // blocks.addClass('filtered');
          // blocks.css('display','');
          // var numItems = 0;

          // // old OR for everything method
          // $.each(blocks, function(index, val) {
          //   // FOCUS AREAS
          //   var dataFilterFocusAreas = ($(this).attr('data-filter-focus-areas')).toString();
          //   if(checkFilter(dataFilterFocusAreas,focus_areas_filters)) $(this).addClass('filtered');
          //   // TREND CLUSTERS
          //   var dataFilterTrendClusters = ($(this).attr('data-filter-trend-clusters')).toString();
          //   if(checkFilter(dataFilterTrendClusters,trend_clusters_filters)) $(this).addClass('filtered');
          //   // SECTORS
          //   var dataFilterSectors = ($(this).attr('data-filter-sectors')).toString();
          //   if(checkFilter(dataFilterSectors,sectors_filters)) $(this).addClass('filtered');
          // });


          // // ---------------------------------
          // // grid-only filters start
          // var grid_filter_matching_nodes = [];
          // // var nodes = $('.ltr6-radar-view .ltr6-node', radarInstance);
          // $.each(blocks, function(index, val) {
          //   var trendName = $(this).attr('data-trend');
          //   var impact = $(this).attr('data-impact');
          //   var realization = $(this).attr('data-realization');
          //   var trendType;
          //   if($(this).hasClass('ltr6-technology-trend')) {
          //     trendType = 0;
          //   } else {
          //     trendType = 1;
          //   }

          //   if(impact < 2 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="lower_impact"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }
          //   if(impact >= 2 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="higher_impact"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }

          //   if(realization == 0 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="within_5_years_realization"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }

          //   if(realization == 1 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="5_to_10_years_realization"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }

          //   if(trendType == 1 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="social_and_business_trends"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }

          //   if(trendType == 0 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="technology_trends"] input', radarInstance).is(':checked')){
          //     grid_filter_matching_nodes.push(trendName);
          //   }

          // });
          // // console.log('checked',$('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="lower_impact"] input', radarInstance).is(':checked'));
          // console.log('grid_filter_matching_nodes',grid_filter_matching_nodes);
          // if(grid_filter_matching_nodes.length>0) matching_nodes = matching_nodes.intersect(grid_filter_matching_nodes);
          // // grid-only filters end
          // // ---------------------------------






          // $.each(blocks, function(index, val) {
          //     var trendName = $(this).attr('data-trend');
          //     if(matching_nodes.includes(trendName)){
          //       // console.log('should be showing',trendName);
          //       $(this).removeClass('filtered');
          //       // $(this).css('display','');
          //     }
          // });

          // paginationDraw(radarInstance);


          //mobile filter toggle filter count
          var activeText = '';
          if(filterCount>0){
            var s = filterCount>1 ? 's':'';
            activeText = '('+filterCount+')';
          }
          $('.ltr6-filter-menu-toggle span.ltr6-active-filters-count', radarInstance).text(activeText);

        } else {
          // RESET

          // clear filter toggles
          // radarInstance.find('.ltr6-radar-filters .ltr6-clear-filters').removeClass('active');
          $('.ltr6-radar-filters .ltr6-clear-filters', radarInstance).removeClass('active');
          $('.ltr6-radar-filters .ltr6-apply-filters', radarInstance).removeClass('active');

          // reset node highlighting
          // $('.ltr6-radar-view .ltr6-node', radarInstance).fadeIn(nodeFadeSpeed);// show hide
          $('.ltr6-radar-view .ltr6-node', radarInstance).removeClass('highlighted');// class
          $('.ltr6-radar-view .ltr6-node', radarInstance).removeClass('disabled');// class

          // // reset grid filtering
          // $('.ltr6-grid-view .ltr6-radar-grid-block', radarInstance).removeClass('filtered');
          // paginationDraw(radarInstance);

          //mobile filter toggle filter count
          $('.ltr6-filter-menu-toggle span.ltr6-active-filters-count', radarInstance).text('');

        }






        // ===========================
        // GRID-ONLY FILTERING
        // ===========================
          // console.log('do grid filtering',$('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch input', radarInstance).is(':checked'));
        if($('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch input', radarInstance).is(':checked')){
          // console.log('do grid filtering');
          // console.log('matching_nodes',matching_nodes);

          // SHOW / HIDE GRID BLOCKS
          // ================================================================
          var blocks = $('.ltr6-grid-view .ltr6-radar-grid-block', radarInstance);
          blocks.addClass('filtered');
          blocks.css('display','');
          var numItems = 0;

          // ---------------------------------
          // grid-only filters start
          var grid_filter_matching_nodes = [];

          var trend_type_matching_nodes = [];
          var realization_matching_nodes = [];
          var impact_matching_nodes = [];

          // var nodes = $('.ltr6-radar-view .ltr6-node', radarInstance);
          $.each(blocks, function(index, val) {
            var trendName = $(this).attr('data-trend');
            var impact = $(this).attr('data-impact');
            var realization = $(this).attr('data-realization');
            var trendType;
            if($(this).hasClass('ltr6-technology-trend')) {
              trendType = 0;
            } else {
              trendType = 1;
            }

            if(impact < 2 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="lower_impact"] input', radarInstance).is(':checked')){
              trend_type_matching_nodes.push(trendName);
            }
            if(impact >= 2 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="higher_impact"] input', radarInstance).is(':checked')){
              trend_type_matching_nodes.push(trendName);
            }

            if(realization == 0 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="within_5_years_realization"] input', radarInstance).is(':checked')){
              realization_matching_nodes.push(trendName);
            }
            if(realization == 1 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="5_to_10_years_realization"] input', radarInstance).is(':checked')){
              realization_matching_nodes.push(trendName);
            }

            if(trendType == 1 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="social_and_business_trends"] input', radarInstance).is(':checked')){
              impact_matching_nodes.push(trendName);
            }
            if(trendType == 0 && $('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="technology_trends"] input', radarInstance).is(':checked')){
              impact_matching_nodes.push(trendName);
            }

          });

          grid_filter_matching_nodes = trend_type_matching_nodes.concat(realization_matching_nodes, impact_matching_nodes);

          if(trend_type_matching_nodes.length && realization_matching_nodes.length){
            grid_filter_matching_nodes = trend_type_matching_nodes.intersect(realization_matching_nodes);
          }
          if(trend_type_matching_nodes.length && impact_matching_nodes.length){
            grid_filter_matching_nodes = trend_type_matching_nodes.intersect(impact_matching_nodes);
          }
          if(realization_matching_nodes.length && impact_matching_nodes.length){
            grid_filter_matching_nodes = realization_matching_nodes.intersect(impact_matching_nodes);
          }
          if(trend_type_matching_nodes.length && realization_matching_nodes.length && impact_matching_nodes.length){
            grid_filter_matching_nodes = trend_type_matching_nodes.intersect(realization_matching_nodes);
            grid_filter_matching_nodes = grid_filter_matching_nodes.intersect(impact_matching_nodes);
          }

          // console.log('matching_nodes',grid_filter_matching_nodes);


          // if no filtering on main filters, set the matching nodes to be complete list
          if(matching_nodes.length<=0) {
            $.each(trends_data, function(index, val) {
              matching_nodes.push(index);
            });
          }
          // console.log('trends_data',trends_data);
          // console.log('matching_nodes',matching_nodes);
          // console.log('checked',$('.ltr6-grid-filters .ltr6-grid-filters-menu .ltr6-toggle-switch[data-filter-name="lower_impact"] input', radarInstance).is(':checked'));
          // console.log('grid_filter_matching_nodes',grid_filter_matching_nodes);

          //intersect filtered matching_nodes with grid only filters
          if(grid_filter_matching_nodes.length>0) matching_nodes = matching_nodes.intersect(grid_filter_matching_nodes);


          // process display blocks
          $.each(blocks, function(index, val) {
              var trendName = $(this).attr('data-trend');
              if(matching_nodes.includes(trendName)){
                // console.log('should be showing',trendName);
                $(this).removeClass('filtered');
                // $(this).css('display','');
              }
          });

          //update pagination
          paginationDraw(radarInstance);

        }
        // end grid only filtering





      };




























      ltr6_module_radar.filter_nodes = function(radarInstance){

      };







      // ================================================================
      // get URL filters
      // ================================================================

// ?sector_filter=auto_mobility
// ?sector_filter=engineering_and_manufacturing
// ?sector_filter=technology
// ?sector_filter=energy
// ?sector_filter=life_sciences_and_healthcare
// ?sector_filter=e_retail_and_fashion

// ?trend_cluster_filter=artificial_intelligence
// ?trend_cluster_filter=bionic_enhancements
// ?trend_cluster_filter=digital_backbone
// ?trend_cluster_filter=internet_of_things
// ?trend_cluster_filter=packaging_and_containers
// ?trend_cluster_filter=robotics

// ?focus_area_filter=automation_and_efficiency
// ?focus_area_filter=customer_experience
// ?focus_area_filter=environmental_sustainability
// ?focus_area_filter=health_safety_and_future_of_work
// ?focus_area_filter=physical_and_digital_security
// ?focus_area_filter=visibility_and_resilience



      // apply filter
      ltr6_module_radar.prefill_filters = function(group,filter){
        if (Array.isArray(filter)) {
          for (var i = 0; i < filter.length; i++) {
            
            var filterElement = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+group+'"] [data-filter-name="'+filter[i]+'"]');
            if(filterElement.length){
              // console.log('applying filter ', group, filter[i]);
              // filterElement.addClass('active');
              filterElement.find('input').prop('checked','checked');
            } else {
              // console.log('filter not found', group, filter[i]);
            }

          }
        } else {

          var filterElement = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+group+'"] [data-filter-name="'+filter+'"]');
          if(filterElement.length){
            // console.log('applying filter ', group, filter);
            // filterElement.addClass('active');
            filterElement.find('input').prop('checked','checked');
          } else {
            // console.log('filter not found', group, filter);
          }

          ltr6_module_radar.toggleGroup($('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group[data-filter-group="'+group+'"]'));
        }
        // timeout caus radar has slight timeout on load.
        setTimeout(function(){
          ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
          ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
        },200);

      };


      var sector_filter = ltr6_module_utilities.getUrlParameter('sector_filter');
      var trend_cluster_filter = ltr6_module_utilities.getUrlParameter('trend_cluster_filter');
      var focus_area_filter = ltr6_module_utilities.getUrlParameter('focus_area_filter');

      if(sector_filter) {
        // console.log('sector_filter found:',sector_filter);
        ltr6_module_radar.prefill_filters('sector',sector_filter);
      }
      if(trend_cluster_filter) {
        // console.log('trend_cluster_filter',trend_cluster_filter);
        ltr6_module_radar.prefill_filters('trend_cluster',trend_cluster_filter);
      }
      if(focus_area_filter) {
        // console.log('focus_area_filter',focus_area_filter);
        ltr6_module_radar.prefill_filters('focus_area',focus_area_filter);
      }

      // console.log(ltr6_module_utilities.getUrlParameters());






      // ================================================================
      // filter groups accordions
      // ================================================================

      var transitionTimeout;
      var cssTransitionSpeed = 500;

      $('#ltr6-wrapper').on('click', '.ltr6-filter-groups .ltr6-filter-group .ltr6-filter-group-accordion-toggle', function(event) {
        event.preventDefault();
        // var clickedGroupName = $(this).closest('.ltr6-filter-group').attr('data-filter-group');
        var group = $(this).closest('.ltr6-filter-group');
        ltr6_module_radar.toggleGroup(group);

        // // analytics
        // var groupName = group.attr('data-filter-group');
        // var groupNiceName = '';
        // if(groupName=='focus_area') groupNiceName = 'Focus Areas';
        // if(groupName=='trend_cluster') groupNiceName = 'Trend Clusters';
        // if(groupName=='sector') groupNiceName = 'Sectors';
        // ltr6_module_analytics.tracking_adobe(groupNiceName,'Button','Click','Trends Filter Group');
        // ltr6_module_analytics.tracking_decibel(groupNiceName,'Button','Click','Trends Filter Group');

        // return;
      });










      // ================================================================
      // clear filters
      // ================================================================
      $('#ltr6-wrapper').on('click', '.ltr6-radar-filters .ltr6-clear-filters', function(event) {
        event.preventDefault();
        // var filters = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group .ltr6-toggle-switch');
        // $.each(filters, function(index, val) {
        //   $(this).find('input').prop("checked",'');
        // });
        // ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
        // ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
        ltr6_module_radar.clear_filters();
      });


      ltr6_module_radar.clear_filters = function(){
        var filters = $('#ltr6-wrapper .ltr6-radar-filters .ltr6-filter-group .ltr6-toggle-switch');
        $.each(filters, function(index, val) {
          $(this).find('input').prop("checked",'');
        });
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
        ltr6_module_radar.apply_filters($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
        ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
        ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
        
      }






      // ================================================================
      // POPUPS
      // ================================================================

      // store mouse position at start, so we can detect if dragging on a node.
      var mouseX, mouseY;
      $('#ltr6-wrapper').on('mousedown', 'a[data-ltr6-trend-popup]', function(event) {
        mouseX = event.clientX;
        mouseY = event.clientY;
        // console.log(mouseX);
      });

      // POPUP click handler
      $('#ltr6-wrapper').on('click', 'a[data-ltr6-trend-popup]', function(event) {

        // detect if dragged, cancel click.
        var distX = Math.abs(event.clientX-mouseX);
        var distY = Math.abs(event.clientY-mouseY);
        var dist = Math.max(distX,distY);
        // console.log(dist);
        if(dist > 2) return false;

        event.preventDefault();
        var trend = $(this).attr('data-ltr6-trend-popup-slug');
        var trendNane = $(this).attr('data-trend-name');
        // console.log(trend);
        populatePopup(trend);
        $.featherlight('#ltr6-trend-popup',{
          variant: 'chromeless'
        });

        // ltr6_module_analytics.tracking_adobe(trendNane,'Button','Click','Trend (Radar)');
        // ltr6_module_analytics.tracking_decibel(trendNane,'Button','Click','Trend (Radar)');
      });


      function populatePopup(trend_slug){
        var data = trends_data[trend_slug];

        // load image avoid FOUC
        // var tmpImg = new Image();
        // tmpImg.src = 'https://local.logistics-trend-radar.com/images/trend_headers/'+data.image+'-2730x854.jpg';
        // tmpImg.onload = function() {
        //   $('#ltr6-wrapper .ltr6-trend-popup .ltr6-trend-popup-image img').attr('src','https://local.logistics-trend-radar.com/images/trend_headers/'+data.image+'-2730x854.jpg');
        // };

        $('#ltr6-wrapper .ltr6-trend-popup .ltr6-trend-popup-image img').attr('src','https://local.logistics-trend-radar-7.com/images/trend_headers/'+data.image+'-800x253.jpg');
        // $('#ltr6-wrapper .ltr6-trend-popup').find('img').attr('src','https://local.logistics-trend-radar.com/images/trend_headers/'+data.image+'-2730x854.jpg');

        $('#ltr6-wrapper .ltr6-trend-popup h4').html(data.title.replace('<br>',' '));

        var impacts = ['Low','Limited','Significant','High'];
        var realization_text = data.realization==0 ? '< 5 Years' : '5 - 10 Years'
        var impact_text = impacts[data.impact];

        var type_text = data.type==0 ? 'Social &amp; Business Trend' : 'Technology Trend';
        $('#ltr6-wrapper .ltr6-trend-popup .ltr6-radar-grid-block-detail-type').html(type_text);
        
        $('#ltr6-wrapper .ltr6-trend-popup').removeClass('ltr6-technology-trend');
        $('#ltr6-wrapper .ltr6-trend-popup').removeClass('ltr6-social-and-business-trend');
        if(data.type==0){
          $('#ltr6-wrapper .ltr6-trend-popup').addClass('ltr6-social-and-business-trend');
        } else {
          $('#ltr6-wrapper .ltr6-trend-popup').addClass('ltr6-technology-trend');
        }

        $('#ltr6-wrapper .ltr6-trend-popup .ltr6-radar-grid-block-impact').html(impact_text);
        $('#ltr6-wrapper .ltr6-trend-popup .ltr6-radar-grid-block-realization').html(realization_text);
        // $('#ltr6-wrapper .ltr6-trend-popup').find('a.base-button').attr('href',data.url);
        $('#ltr6-wrapper .ltr6-trend-popup .ltr6-trend-popup-content-excerpt').html('<p>'+data.excerpt+'</p>');

        // url
        // console.log(window.location);
        var location = window.location;


        // if(location.pathname.indexOf('simulator.php')){
        //   $('#ltr6-wrapper .ltr6-trend-popup a.base-button').attr('href','https://local.logistics-trend-radar-7.com/simulator.php?module='+trend_slug);
        // } else {
        //   // var ltr6_baseurl = url.slice(0,1);
        //   $('#ltr6-wrapper .ltr6-trend-popup a.base-button').attr('href',ltr6_baseurl+data.url);
        // }
        
        $('#ltr6-wrapper .ltr6-trend-popup a.base-button').attr('href',ltr6_baseurl+data.url);

      }

      //   // console.log('popup');
      // $('#ltr6-wrapper a[data-ltr6-trend-popup]').featherlight({
      //   targetAttr: 'data-ltr6-trend-popup',
      //   variant: 'chromeless',
      //   beforeOpen: function(event){
      //     console.log($(event.currentTarget).attr('data-ltr6-trend-popup-slug'));
      //     // console.log(this);
      //     var trend_slug = $(event.currentTarget).attr('data-ltr6-trend-popup-slug');
      //     populatePopup(trend_slug);
      //   }
      // });










      // // ================================================================
      // // GRID PAGINATION
      // // ================================================================
      // // simplePagination
      // // http://flaviusmatis.github.io/simplePagination.js/#page-65
      // // https://stackoverflow.com/questions/20896076/how-to-use-simplepagination-jquery


      // // The blocks are hidden with CSS to avoid FOUC
      // // var items = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-grid-view .ltr6-radar-grid-block:not(.filtered)');
      // // var numItems = items.length;
      // // console.log(numItems);
      // // var perPage = 6;
      // // items.slice(perPage).hide();
      // // items.slice(0,perPage).show();
      // // items.slice(perPage).addClass('filtered');

      // var perPage = 12;
      // var oldPerPage;

      // // paginationDraw($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      // // paginationDraw($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));

      // // width change redraw pagination
      // var repaginateOnScreenWidthChange = ltr6_module_utilities.debounce(function() {
      //   var width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      //   // var height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
      //   if(width<500){
      //     perPage = 8;
      //   } else {
      //     perPage = 12;
      //   }
      //   if(oldPerPage!=perPage){
      //     // console.log('repaginating the grid');
      //     // if($('#ltr6-wrapper .ltr6-interactive-radar .ltr6-grid-view').is(":visible")){
      //       paginationDraw($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      //       paginationDraw($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
      //     // }
      //   }
      //   oldPerPage = perPage;
      // }, 50);
      // window.addEventListener('resize', repaginateOnScreenWidthChange);
      // // do on load
      // repaginateOnScreenWidthChange();


      // // redraw pagination n all dat.
      // function paginationDraw(radarInstance){

      //   // var items = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-grid-view .ltr6-radar-grid-block:not(.filtered)');
      //   var items = $('.ltr6-grid-view .ltr6-radar-grid-block:not(.filtered)', radarInstance);
      //   var numItems = items.length;
      //   // console.log(numItems);
      //   // perPage = 12; // NOW SET GLOBALLY!
      //   // var perPage = 10; //grid alt
      //   items.show();
      //   items.slice(perPage).hide();

      //   $('.ltr6-grid-view-pagination', radarInstance).pagination('destroy');
      //   $('.ltr6-grid-view-pagination', radarInstance).pagination({
      //       items: numItems,
      //       itemsOnPage: perPage,
      //       cssStyle: 'dhl-theme',
      //       prevText: '<span class="has-icon icon-chevron-back"></span>',
      //       nextText: '<span class="has-icon icon-chevron-forward"></span>',
      //       onPageClick: function(pageNumber) {
      //           var showFrom = perPage * (pageNumber - 1);
      //           var showTo = showFrom + perPage;
      //           items.hide();
      //           items.slice(showFrom, showTo).fadeIn(200);
      //           // items.addClass('filtered');
      //           // items.slice(showFrom, showTo).removeClass('filtered');
      //       }
      //   });
      // }

      // function paginationFiltered(radarInstance){
      //   $('#ltr6-wrapper .ltr6-grid-view .ltr6-radar-grid-block', radarInstance).hide();

      //   var items = $('#ltr6-wrapper .ltr6-grid-view .ltr6-radar-grid-block.filtered', radarInstance);
      //   var numItems = items.length;
      //   var perPage = 12;
      //   items.slice(0,perPage).show();
      //   // $('.ltr6-grid-view-pagination').pagination('redraw');
      //   $('.ltr6-grid-view-pagination', radarInstance).pagination('destroy');
      //   $('.ltr6-grid-view-pagination', radarInstance).pagination({
      //       items: numItems,
      //       itemsOnPage: perPage,
      //       cssStyle: 'dhl-theme',
      //       prevText: '<span class="has-icon icon-chevron-back"></span>',
      //       nextText: '<span class="has-icon icon-chevron-forward"></span>',
      //       onPageClick: function(pageNumber) {
      //           var showFrom = perPage * (pageNumber - 1);
      //           var showTo = showFrom + perPage;
      //           items.hide();
      //           items.slice(showFrom, showTo).fadeIn(200);
      //           // items.addClass('filtered');
      //           // items.slice(showFrom, showTo).removeClass('filtered');
      //       }
      //   });
      // }




      // // ================================================================
      // // ORDERING
      // // ================================================================
      // $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-grid-view-ordering').on('click', '.ltr6-select li', function(event) {
      //   var orderby = $(this).attr('ltr6-data-orderby');
      //   var order = $(this).attr('ltr6-data-order');


      //   // console.log('order',order);
      //   // console.log('orderby',orderby);
      //   orderGrid($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'),order,orderby);
        
      //   if($('#ltr6-wrapper .ltr6-navigation-radar-wrapper').length){
      //     orderGrid($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'),order,orderby); //sync
      //     //sync other select
      //     var text = $(this).text();
      //     var otherSelect = $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-select');
      //     otherSelect.find('li.active-option').removeClass('active-option');
      //     otherSelect.find('[ltr6-data-order="'+order+'"][ltr6-data-orderby="'+orderby+'"]').addClass('active-option');
      //     otherSelect.find('.select-value').text(text);
      //   }
      // });

      // $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-grid-view-ordering').on('click', '.ltr6-select li', function(event) {
      //   var orderby = $(this).attr('ltr6-data-orderby');
      //   var order = $(this).attr('ltr6-data-order');

      //   // console.log('order',order);
      //   // console.log('orderby',orderby);
      //   orderGrid($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'),order,orderby);

      //   if($('#ltr6-wrapper .ltr6-interactive-radar-wrapper').length){
      //     orderGrid($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'),order,orderby); //sync
      //     //sync other select
      //     var text = $(this).text();
      //     var otherSelect = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-select');
      //     otherSelect.find('li.active-option').removeClass('active-option');
      //     otherSelect.find('[ltr6-data-order="'+order+'"][ltr6-data-orderby="'+orderby+'"]').addClass('active-option');
      //     otherSelect.find('.select-value').text(text);
      //   }

      // });

      // function orderGrid(instance,order,orderby){
      //   // var ul = document.getElementById(ul);
      //   var blocks = $('.ltr6-grid-view .ltr6-radar-grid-block',instance);
      //   blocks.remove();
      //   // console.log(blocks.length);
      //   // $.each(blocks, function(index, val) {
      //   //   $(this).remove();
      //   // });
      //   // blocks.sort(asc_sort).appendTo('.list');
      //   // blocks.sort(asc_sort);
      //   // console.log('order',order);
      //   // console.log('orderby',orderby);

      //   //sort alphabetically first 
      //   blocks.sort(sort_alpha_desc);

      //   if(order=='alpha' && orderby=='asc'){
      //     blocks.sort(sort_alpha_asc);
      //   }

      //   if(order=='alpha' && orderby=='desc'){
      //     blocks.sort(sort_alpha_desc);
      //   }

      //   if(order=='impact' && orderby=='asc'){
      //     blocks.sort(sort_impact_asc);
      //   }
      //   if(order=='impact' && orderby=='desc'){
      //     blocks.sort(sort_impact_desc);
      //   }

      //   if(order=='realization' && orderby=='asc'){
      //     blocks.sort(sort_realization_asc);
      //   }
      //   if(order=='realization' && orderby=='desc'){
      //     blocks.sort(sort_realization_desc);
      //   }

      //   $('.ltr6-grid-view .ltr6-radar-grid',instance).append(blocks);





      // // paginationDraw($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      //   paginationDraw(instance);



      // }
      // function sort_alpha_asc(a, b){
      //     return ($(b).attr('data-trend-name')) < ($(a).attr('data-trend-name')) ? 1 : -1;    
      // }
      // function sort_alpha_desc(a, b){
      //     return parseInt($(b).attr('data-trend-name')) > parseInt($(a).attr('data-trend-name')) ? 1 : -1;    
      // }
      // function sort_impact_asc(a, b){
      //     return parseInt($(b).attr('data-impact-pc')) < parseInt($(a).attr('data-impact-pc')) ? 1 : -1;    
      // }
      // function sort_impact_desc(a, b){
      //     return parseInt($(b).attr('data-impact-pc')) > parseInt($(a).attr('data-impact-pc')) ? 1 : -1;    
      // }
      // function sort_realization_asc(a, b){
      //     return parseInt($(b).attr('data-realization-pc')) < parseInt($(a).attr('data-realization-pc')) ? 1 : -1;    
      // }
      // function sort_realization_desc(a, b){
      //     return parseInt($(b).attr('data-realization-pc')) > parseInt($(a).attr('data-realization-pc')) ? 1 : -1;    
      // }






      // ================================================================
      // NODES
      // ================================================================

      //double layered version - allows transparent background and solid text
      var nodeTemplate = $('<div class="ltr6-node"><a href="#" data-ltr6-trend-popup="#ltr6-trend-popup"  data-ltr6-trend-popup-slug=""><span class="ltr6-node-bg">This is a node</span></a><span class="ltr6-node-text">This is a node</span></div>');
      // single layer version, no doubled text
      // var nodeTemplate = $('<div class="ltr6-node"><span>This is a node</span></div>');

      $.each(trends_data, function(index, trend) {
        var node = nodeTemplate.clone();
        node.find('span').html(trend.title);
        node.addClass('ltr6-node-align-'+trend.align);
        var type = trend.type == 0 ? 'ltr6-social-and-business-trend' : 'ltr6-technology-trend';
        node.addClass(type);
        // console.log('trend.key',index);
        node.attr('data-trend',index);
        node.attr('data-trend-name',trend.title);
        node.find('a').attr('data-ltr6-trend-popup-slug',index);
        node.attr('data-filter-focus-areas',trend.focus_areas);
        node.attr('data-filter-trend-clusters',trend.trend_clusters);
        node.attr('data-filter-sectors',trend.sectors);

        if(trend.width != null){
          // console.log('trend',trend.width);
          node.width('100px');
          node.find('span').width('100px');
        }

        // offset now done in php. numbers in data are from the center point, converted to be top left.
        // trend.x = trend.x + 1167;
        // trend.y = trend.y + 1143;

        node.css({'top':trend.y+'px','left':trend.x+'px'});
        // var randX = Math.floor(Math.random() * 60)+20;
        // var randY = Math.floor(Math.random() * 60)+10;
        // node.css({'top':randY+'%','left':randX+'%'});

        $('#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view .ltr6-radar-panzoom').append(node);
        var node2 = node.clone();
        $('#ltr6-wrapper .ltr6-navigation-radar-wrapper .ltr6-radar-view .ltr6-radar-panzoom').append(node2);
        // console.log(trend.x);
      });




    }; //end init function

    // ltr6_module_radar.goToTrend = function(trendSlug){
      
    // }


    ltr6_module_radar.toggleGroup = function(group){
      var clickedGroupName = group.attr('data-filter-group');


      // -- sync mode - landing page and popup synced:
      var groups = $('.ltr6-filter-groups .ltr6-filter-group');

      // -- independent mode = landing page and popup independent
      // var groups = group.parent().find('.ltr6-filter-group');


      $.each(groups, function(index, val) {
        var thisGroup = $(this);
        var thisGroupName = thisGroup.attr('data-filter-group');
        if(clickedGroupName == thisGroupName){
          if(thisGroup.hasClass('active')) {
            ltr6_module_radar.closeGroup(thisGroup); // comment out keep one open all times
            return;
          }
          ltr6_module_radar.openGroup(thisGroup);
        } else {
          ltr6_module_radar.closeGroup(thisGroup);
        }
      });


    }

    ltr6_module_radar.openGroup = function(group){
      // if(group.hasClass('active')) {
      //   ltr6_module_radar.closeGroup(group);
      //   return;
      // }
      var expandableRegion = group.find('.ltr6-filter-group-content');
      var expandedHeight = expandableRegion[0].scrollHeight;
      expandableRegion.css('height',expandedHeight);
      group.addClass('active');
      group.find('.ltr6-filter-group-accordion-toggle').blur();
      openTransitionTimeout = setTimeout(function(){
        if(!group.hasClass('active')) return;
        expandableRegion.css('height','auto');
        expandableRegion.css('overflow','visible');
      }, 500);
    }
    ltr6_module_radar.closeGroup = function(group){
      // clearTimeout(closeTransitionTimeout);
      var expandableRegion = group.find('.ltr6-filter-group-content');
      var expandedHeight = expandableRegion[0].scrollHeight;
      expandableRegion.css('height',expandedHeight);
      expandableRegion.css('overflow','hidden');
      group.find('.ltr6-filter-group-accordion-toggle').blur();
      closeTransitionTimeout = setTimeout(function(){
        expandableRegion.css('height',0);
        group.removeClass('active');
      }, 0);
    }

    ltr6_module_radar.openMobileFilterMenu = function(radarInstance){
      $('.ltr6-filter-menu-toggle',radarInstance).addClass('active');
      $('.ltr6-filters-col',radarInstance).addClass('mobile-expanded');
      ltr6_module_grid_filters.closeGridFilterMenu();
      setTimeout(function(){
        $('body').on('click', closeMobileFilterMenuOnOutsideClick);
      },0);
      ltr6_module_analytics.tracking_adobe('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
      ltr6_module_analytics.tracking_decibel('Open Filter Menu','Button','Click','Filter Menu (Mobile)');
    }
    ltr6_module_radar.closeMobileFilterMenu = function(radarInstance){
      $('.ltr6-filter-menu-toggle',radarInstance).removeClass('active');
      $('.ltr6-filters-col',radarInstance).removeClass('mobile-expanded');
      $('body').off('click', closeMobileFilterMenuOnOutsideClick);
    }
    function closeMobileFilterMenuOnOutsideClick(e){
      if($('.ltr6-tour-active').length) return;
      if($(e.target).closest('.ltr6-filters-col').length) return;
      ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-interactive-radar-wrapper'));
      ltr6_module_radar.closeMobileFilterMenu($('#ltr6-wrapper .ltr6-navigation-radar-wrapper'));
      $('body').off('click', closeMobileFilterMenuOnOutsideClick);
    }

    return ltr6_module_radar;
}(ltr6_module_radar || {}));
